import { type GasPayload } from '@atlaskit/analytics-gas-types';

export type IntentRouterExperimentExposedAttributes = {
	searchSessionId: string;
	cohort: string;
	modelId: string;
	queryLength: number;
};

export const onIntentRouterExperimentExposed = ({
	attributes,
}: {
	attributes: IntentRouterExperimentExposedAttributes & Record<string, any>;
}): GasPayload => ({
	source: 'searchDialog',
	eventType: 'track',
	action: 'exposed',
	actionSubject: 'intentRouterExperiment',
	actionSubjectId: 'intentRouterExperimentExposed',
	attributes,
});
